/**
 * Inscriptions, Inscription Stats, Public Inscriptions, Public Emargement endpoints
 */

function withQueryString(path, params) {
  return params ? `${path}?${new URLSearchParams(params)}` : path
}

export const inscriptionsEndpoints = {
  create: () => `/api/inscriptions`,
  list: (params) => withQueryString('/api/inscriptions', params),
  organisationFormation: (params) => withQueryString('/api/inscriptions/organisation-formation', params),
  counts: (params) => withQueryString('/api/inscriptions/counts', params),
  detail: (id) => `/api/inscriptions/${id}`,
  update: (id) => `/api/inscriptions/${id}`,
  updateStatus: (id) => `/api/inscriptions/${id}/status`,
  history: (id) => `/api/inscriptions/${id}/history`,
  allowedTransitions: (id) => `/api/inscriptions/${id}/allowed-transitions`,
  createStagiaire: (inscriptionId) => `/api/inscriptions/${inscriptionId}/stagiaire`,
  updateStagiaire: (inscriptionId, stagiaireId) => `/api/inscriptions/${inscriptionId}/stagiaire/${stagiaireId}`,
  generateToken: (id) => `/api/inscriptions/${id}/generate-token`,
  sendOneShot: (id) => `/api/inscriptions/${id}/send-one-shot`,
  delete: (id) => `/api/inscriptions/${id}`,
  restore: (id) => `/api/inscriptions/${id}/restore`,
  markPaymentReceived: (id) => `/api/inscriptions/${id}/mark-payment-received`,
  retryPaymentConfirmation: (id) => `/api/inscriptions/${id}/retry-payment-confirmation`,
  resendPaymentLink: (id) => `/api/inscriptions/${id}/resend-payment-link`,
  formCommercial: (id) => `/api/inscriptions/${id}/form-commercial`,
  submitCommercial: (id) => `/api/inscriptions/${id}/submit-commercial`,
  createBatch: () => '/api/inscriptions/batch',
  group: (id) => `/api/inscriptions/${id}/group`,
  attestationDownload: (id) => `/api/inscriptions/${id}/attestation-download`,
  resendConvocations: (id) => `/api/inscriptions/${id}/resend-convocations`,
  documents: {
    generate: (id) => `/api/inscriptions/${id}/documents`,
    list: (id) => `/api/inscriptions/${id}/documents`,
    download: (id, docId) => `/api/inscriptions/${id}/documents/${docId}/download`,
    upload: (id) => `/api/inscriptions/${id}/documents/upload`,
    uploadConventionPrestataire: (id) => `/api/inscriptions/${id}/documents/upload-convention-prestataire`,
  },
  emargements: {
    generate: (id) => `/api/inscriptions/${id}/emargements/generate`,
    list: (id) => `/api/inscriptions/${id}/emargements`,
    sessionTable: (id) => `/api/inscriptions/${id}/emargements/session`,
    manualOverride: (emargementId) => `/api/emargements/${emargementId}/manual`,
  },
  reminders: {
    list: (id) => `/api/inscriptions/${id}/reminders`,
    cancel: (id, reminderId) => `/api/inscriptions/${id}/reminders/${reminderId}`,
  },
  automaticEmails: {
    list: (id) => `/api/inscriptions/${id}/automatic-emails`,
  },
  questionnaires: {
    list: (id) => `/api/inscriptions/${id}/questionnaires`,
    responses: (id, envoiId) => `/api/inscriptions/${id}/questionnaires/${envoiId}/responses`,
    form: (id, envoiId) => `/api/inscriptions/${id}/questionnaires/${envoiId}/form`,
    send: (id) => `/api/inscriptions/${id}/questionnaires/send`,
  },
}

export const dossiersPedagogiquesEndpoints = {
  create: () => '/api/dossiers-pedagogiques',
  list: (params) => withQueryString('/api/dossiers-pedagogiques', params),
  detail: (id) => `/api/dossiers-pedagogiques/${id}`,
  saisirNumeroSuivi: (id) => `/api/dossiers-pedagogiques/${id}/numero-suivi`,
  rePreparer: (id) => `/api/dossiers-pedagogiques/${id}/re-preparer`,
  updateNotes: (id) => `/api/dossiers-pedagogiques/${id}/notes`,
  delete: (id) => `/api/dossiers-pedagogiques/${id}`,
}

export const inscriptionStatsEndpoints = {
  summary: () => '/api/inscription-stats/summary',
}

export const publicInscriptionsEndpoints = {
  directInscription: () => '/api/public/inscriptions/direct',
  getForm: (token) => `/api/public/inscriptions/form?token=${encodeURIComponent(token)}`,
  submitForm: () => '/api/public/inscriptions/form',
  devisPreview: () => '/api/public/inscriptions/devis-preview',
  createCheckoutSession: () => '/api/public/inscriptions/create-checkout-session',
  paymentSuccess: (sessionId) => `/api/public/inscriptions/payment-success?session_id=${encodeURIComponent(sessionId)}`,
  getPrestataireResponse: (token) => `/api/public/inscriptions/prestataire-response?token=${encodeURIComponent(token)}`,
  submitPrestataireResponse: () => '/api/public/inscriptions/prestataire-response',
  selectAlternative: (altToken) => `/api/public/inscriptions/select-alternative?token=${encodeURIComponent(altToken)}`,
  uploadAttestation: () => '/api/public/inscriptions/upload-attestation',
  deleteAttestation: () => '/api/public/inscriptions/delete-attestation',
}

export const publicEmargementEndpoints = {
  // Nouveau paradigme : 1 QR = 1 inscription (toutes les demi-journees)
  getByInscription: (token) => `/api/public/emargement/inscription?token=${encodeURIComponent(token)}`,
  confirmById: () => '/api/public/emargement/confirm-by-id',
  // Legacy (retrocompatibilite)
  get: (token) => `/api/public/emargement?token=${encodeURIComponent(token)}`,
  confirm: () => '/api/public/emargement/confirm',
}

export const publicFormateurEmargementEndpoints = {
  session: (token) => `/api/public/formateur-emargement/session?token=${encodeURIComponent(token)}`,
  signer: () => '/api/public/formateur-emargement/signer',
  marquerAbsent: () => '/api/public/formateur-emargement/marquer-absent',
  ajouterStagiaire: () => '/api/public/formateur-emargement/ajouter-stagiaire',
  signerStagiaire: () => '/api/public/formateur-emargement/signer-stagiaire',
}
